<template>
    <div>
        <v-container>
            <v-row>
                <v-col cols="12">
                    <h5 class="text-center">Telemetria as a Service</h5>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-img
                        src="../assets/images/instance_logo_login.png"
                        class="justify-center"
                        width="290px"
                        ></v-img>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <h3 class="text-center">Área de Acesso</h3>
                </v-col>
            </v-row>
            <v-row v-if="!this.hasInstancesList()">
                <v-col cols="12">
                    <v-text-field
                        id="username"
                        label="E-mail"
                        hide-details="auto"
                        v-model="username"
                        ></v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="!this.hasInstancesList()">
                <v-col cols="12">
                    <v-text-field
                        :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show4 ? 'text' : 'password'"
                        @click:append="show4 = !show4"
                        id="password"
                        label="Senha"
                        hide-details="auto"
                        v-model="password"
                        ></v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="this.hasInstancesList()">
                <v-col cols="12">
                    <div class="my-2 justify-center text-center">
                        <v-btn
                            color="primary"
                            primary
                            large
                            class="justify-center text-center v-btn-list"
                            @click="login(instanceItem.index)"
                            v-for="instanceItem in instances"
                            :key="instanceItem.index"
                            >
                            <v-icon>mdi-login</v-icon>&nbsp; {{ instanceBtnTx }} em
                            {{ instanceItem.name }}
                        </v-btn>
                    </div>
                </v-col>
                <v-col cols="12">
                    <div class="my-2 justify-center text-center">
                        <v-btn
                            color="warning"
                            primary
                            large
                            class="justify-center text-center"
                            @click="resetPage()"
                            >
                            <v-icon>mdi-keyboard-backspace</v-icon>&nbsp; Voltar
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row v-if="!this.hasInstancesList()">
                <v-col cols="12">
                    <div class="my-2 justify-center text-center">
                        <v-btn
                            color="primary"
                            primary
                            large
                            class="justify-center text-center"
                            @click="login()"
                            >
                            <v-icon>mdi-login</v-icon>&nbsp; Entrar
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-img
                        src="../assets/images/vendor_logo.png"
                        class="justify-center"
                        aspect-ratio="2.4"
                        width="172px"
                        ></v-img>
                </v-col>
            </v-row>
            <v-row v-if="!isMobile()">
                <v-col cols="12" class="justify-center text-center">
                    <v-btn
                        v-if="showInstallBtn"
                        id="install-button"
                        type="button"
                        class=""
                        color="warning"
                        warning
                        large
                        @click="installPromotion()"
                        >
                        Instalar no aparelho
                    </v-btn>
                </v-col>
            </v-row>
            <div id="app-version">Ver: {{ appVersionShow }}</div>
        </v-container>
    </div>
</template>

<script>
    import axios from "axios";
    import { EventBus } from "@/event-bus";
    import { appVersion } from "../../app-version.js";

    export default {
        name: "Login",
        props: {
            //username: String,
        },
        data: function () {
            return {
                defaultHeaders: this.$defaultHeaders,
                token: this.$route.params.token,
                tokenKey: this.$appTokenKey,
                userKey: this.$appUserKey,
                username: "",
                password: "",
                show4: false,
                rootApi: process.env.VUE_APP_ROOT_API,
                loginSuccess: false,
                instance: "",
                instances: [],
                instanceBtnTx: "Entrar",
                showInstallBtn: true,
                deferredPrompt: null,
            };
        },
        created: function () {
            EventBus.$emit("eventShowMenu", false);
            EventBus.$emit("eventPageLoad", {
                name: "Login",
            });

            window.localStorage.setItem(this.$appTokenKey, "");

            //this.installPromotion();

            if (window.matchMedia("(display-mode: standalone)").matches) {
                this.showInstallBtn = false;
            }

            window.addEventListener("beforeinstallprompt", (e) => {
                this.deferredPrompt = e;
            });

            this.appVersionShow = appVersion;
        },

        methods: {
            installPromotion: async function () {
                if (this.deferredPrompt === null) {
                    return;
                }

                this.deferredPrompt.prompt();
                const {outcome} = await this.deferredPrompt.userChoice;
                if (outcome === "accepted") {
                    this.deferredPrompt = null;
                }
            },

            resetPage: function () {
                this.instance = null;
                this.instances = [];
            },

            hasInstancesList: function () {
                return this.instances.length > 0;
            },

            hideMenu: function () {
                EventBus.$emit("eventShowMenu", false);
            },

            choseInstance: async function (instances) {},

            login: async function (index) {
                EventBus.$emit("eventWaitingStart");

                this.username = this.username.trim();
                this.password = this.password.trim();
                this.instance = index;

                try {
                    const response = await this.requestAuth();

                    EventBus.$emit("eventWaitingEnd");

                    // Gerenciamento de lista de instâncias
                    if (response.data.instances) {
                        this.instances = response.data.instances;
                        this.persistInstancelist();
                        if (this.instances.length > 1) {
                            //Tem mais de uma instância
                            this.instanceBtnTx = "Entrar";
                            return;
                        }
                        //Se na lista somente houver uma, loga automagicamente nela
                        this.instanceBtnTx = "Entrando";
                        if (this.instances[0]) {
                            return this.login(this.instances[0].index);
                        }
                        return this.loginFail();
                    }

                    this.loginSuccess = response.data && response.data.jwt !== "";

                    if (!this.loginSuccess) {
                        return this.loginFail();
                    }

                    this.writeAuthData(response.data);

                    EventBus.$emit("eventShowMenu", true);
                    EventBus.$emit("eventSetPageName", "");

                    setTimeout(() => {
                        return this.$router.push({
                            name: "SubdepList",
                            params: {gotoMain: true},
                        });
                    }, 2000);
                    return;
                } catch (e) {
                    console.log(e);
                }
            },

            writeAuthData: function (data) {
                window.localStorage.setItem(this.tokenKey, data.jwt);
                window.localStorage.setItem(this.userKey, JSON.stringify(data.user));
                EventBus.$emit("eventSetUser", data.user);
            },

            requestAuth: async function () {
                const url = this.rootApi + "/login";

                const postBody = {
                    username: this.username,
                    password: this.password,
                    instance: this.instance,
                };

                const headers = axios.getHeaders();
                return axios.post(url, postBody, headers);
            },

            requestInstances: function () {
                const url = this.rootApi + "/getInstances";

                const postBody = {
                    username: this.username,
                    password: this.password,
                };

                const headers = axios.getHeaders();
                return axios.post(url, postBody, headers);
            },

            loginFail: function () {
                alert("E-mail ou senha inválidos");
            },

            isMobile() {
                return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
            },

            persistInstancelist() {
                if (!this.instances) {
                    return;
                }
                window.localStorage.setItem("lastInstanceList", JSON.stringify(this.instances));
            }
        }
    };
</script>

<style>
    .v-btn-list {
        margin: 1px;
        width: 80%;
    }

    #app-version {
        position: absolute;
        bottom: 0px;
        right: 10px;
        font-size: 10px;
    }
</style>
